export default {
  date: (state: {[key:string]: string}) => {
    return state.date
  }
}
